import {
    Column,
    Entity,
    Index,
    JoinColumn,
    ManyToOne,
    OneToMany, OneToOne,
    PrimaryGeneratedColumn, VersionColumn,
} from "typeorm";
import { Project } from "./Project";
import { BetaReaderProfile } from "./BetaReaderProfile";

@Index("project_match_type_pkey", ["id"], {unique: true})
@Entity("project_match_type")
export class ProjectMatchType {
    @PrimaryGeneratedColumn({type: "bigint", name: "id"})
    id!: number;

    @Column({type: "text", name: "project_match_status"})
    projectMatchStatus!: string;

    @Column({type: "int", name: "match_score"})
    matchScore!: number;

    @ManyToOne( (type) => Project)
    @JoinColumn([{name: "project_id", referencedColumnName: "id"}])
    project!: Project;

    @ManyToOne( (type) => BetaReaderProfile)
    @JoinColumn([{name: "beta_reader_id", referencedColumnName: "id"}])
    betaReader!: BetaReaderProfile;
}